export default {
    en: {
        saveBtn: 'Save',
        cancelBtn: 'Cancel',
        searchBtn: 'Search',
        searchHeader: 'Search data',
        // login
        LoginButton: 'Login',
        login_title: 'Login',
        login_subtitle: 'Please fill data to login',
        login_username: 'Username',
        login_password: 'Password',
        login_confirm: 'Login',
        login_validate_username: 'Username is required.',
        login_validate_password: 'Password is required.',
        login_invalid: 'Not found! Please try again.',

        Logout: 'Logout'
    },

    th: {
        addBtn: 'เพิ่มข้อมูล',
        selectBtn: 'เลือก',
        saveBtn: 'บันทึกข้อมูล',
        viewBtn: 'ดูข้อมูล',
        editBtn: 'แก้ไข',
        deleteBtn: 'ลบ',
        confirmBtn: 'ตกลง',
        cancelBtn: 'ยกเลิก',
        clearBtn: 'ล้างข้อมูล',
        searchBtn: 'ค้นหา',
        keyword: 'คำค้นหา',
        receiveDate: 'วันที่รับข้อมูล',
        startDate: 'จากวันที่',
        toDate: 'ถึงวันที่',
        searchHeader: 'ค้นหาข้อมูล',
        controlTable: 'จัดการ',
        TableEmpty: 'ไม่มีข้อมูล',
        enableBtn: 'เปิด',
        disbleBtn: 'ยกเลิก',
        user_profile: 'ภาพผู้ใช้งาน',
        shop_profile: 'ภาพผู้ร้านค้า/บริการ',
        closeBtn: 'ปิด',
        ConfirmDelete: 'ยืนยันการลบข้อมูล',
        ConfirmDeleteSub: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

        ConfirmEnable: 'ยืนยันการเปิดการใช้งาน',
        ConfirmEnableSub: 'คุณต้องการเปิดการใช้งานนี้ใช่หรือไม่ ?',

        ConfirmDisable: 'ยืนยันการปิดการใช้งาน',
        ConfirmDisableSub: 'คุณต้องการปิดการใช้งานนี้ใช่หรือไม่ ?',

        ConfirmCloseModal: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
        ConfirmCloseModalSub: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

        ConfirmApproveModal: 'ยืนยันเหตุสาธารณภัย',

        placeholderSelectBox: 'กรุณาเลือกข้อมูล',
        selectAll: 'เลือกทั้งหมด',
        organize: 'สังกัด',
        level: 'ระดับสิทธิ์',
        lat: 'ละติจูด (X)',
        lon: 'ลองจิจูด (Y)',
        openMapBtn: 'เปิดแผนที่',
        map: 'แผนที่',
        remark: 'ข้อมูลเพิ่มเติม',
        support_disaster: 'สาธารณภัยที่รองรับ',
        related_disaster: 'สาธารณภัยที่เกี่ยวข้อง',
        response_agency: 'หน่วยงานที่รับผิดชอบ',
        location: 'ที่ตั้ง',
        contact_name: 'ชื่อผู้ติดต่อ',
        contact_phone: 'เบอร์โทรศัพท์ผู้ติดต่อ',
        description: 'คำอธิบาย',
        phone_number: 'เบอร์โทรศัพท์',
        mobile_phone_number: 'โทรศัพท์มือถือ',
        fax_number: 'เบอร์โทรสาร (Fax)',
        email: 'อีเมล',
        website: 'เว็บไซต์',
        response_area: 'พื้นที่รับผิดชอบ',
        communication: 'การสื่อสาร',

        // Organization table
        OrganizeModalHeader: 'ค้นหาข้อมูลสังกัด/หน่วยงาน',
        organize_name: 'ชื่อสังกัด/หน่วยงาน',
        organize_type: 'ประเภทสังกัด/หน่วยงาน',
        organize_original: 'ต้นสังกัด',
        organize_location: 'สถานที่ตั้ง',
        province: 'จังหวัด',
        amphur: 'เขต/อำเภอ',
        tambon: 'แขวง/ตำบล',
        postcode: 'รหัสไปรษณีย์',

        // logout
        LogoutButton: 'ลงชื่อออกจากระบบ',
        logout_title: 'ลงชื่อออกจากระบบ',

        // login
        LoginButton: 'ลงชื่อเข้าใช้ระบบ',
        login_title: 'ลงชื่อเข้าใช้ระบบ',
        login_subtitle: 'กรุณาระบุข้อมูลให้ครบถ้วนเพื่อเข้าสู่ระบบ',
        login_username: 'ชื่อผู้ใช้งาน',
        login_password: 'รหัสผ่าน',
        login_confirm: 'เข้าสู่ระบบ',
        login_validate_username: 'กรุณาระบุชื่อผู้ใช้งาน',
        login_validate_password: 'กรุณาระบุรหัสผ่าน',
        login_invalid: 'ไม่พบผู้ใช้งานในระบบ! โปรดลองอีกครั้ง',
        Logout: 'ออกจากระบบ',

        // suggestion 
        suggestion_modal_title: 'เพิ่มข้อเสนอแนะ',
        suggestion_modal_title_edit: 'แก้ไขข้อเสนอแนะ',
        suggestion_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        suggest_date: 'วันที่รับข้อมูล',
        suggest_reply: 'บันทึกการตอบรับ',
        suggest_name: 'ชื่อผู้เสนอแนะ',
        suggest_email_phone: 'Email / เบอร์โทรศัพท์',
        suggest_topic: 'หัวข้อ',
        suggest_detail: 'รายละเอียด',
        suggest_editor: 'บันทึกการแก้ไข',
        suggest_readerStatus: 'สถานะการเปิดอ่าน',

        suggestion_receiveDate_validate: 'กรุณาระบุวันที่รับข้อมูล',
        suggestion_toDate_validate: 'กรุณาระบุวันที่สิ้นสุด',

        // Admin => Permission Level Page
        permission_modal_title_add: 'เพิ่มข้อมูลระดับสิทธิ์',
        permission_modal_title_edit: 'แก้ไขข้อมูลระดับสิทธิ์',
        permission_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        permission_level: 'สังกัดระดับสิทธิ์',
        permission_codeLevel: 'รหัสระดับสิทธิ์',
        permission_nameLevel: 'ชื่อระดับสิทธิ์',
        permission_improvementCheck: 'แจ้งเตือนรายการที่ต้องปรับปรุง (ทั้งหมด)',
        permission_level_validate: 'กรุณาระบุข้อมูลสังกัดระดับสิทธิ์',
        permission_codeLevel_validate: 'กรุณาระบุข้อมูลรหัสระดิบสิทธิ์',
        permission_nameLevel_validate: 'กรุณาระบุชื่อระดับสิทธิ์',
        permission_checkNotification: 'แจ้งเตือนรายการที่ต้องปรับปรุง (ทั้งหมด)',

        // Admin => System User Page
        isu_modal_title_add: 'เพิ่มข้อมูลผู้ใช้งานระบบ',
        isu_modal_title_edit: 'แก้ไขข้อมูลผู้ใช้งานระบบ',
        isu_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        isu_username: 'ชื่อผู้ใช้งาน',
        isu_password: 'รหัสผ่าน',
        isu_password_generate: 'สร้างรหัสผ่านอัตโนมัติ',
        isu_password_reset: 'คลิกที่นี่เพื่อ Reset Password',
        isu_fullname: 'ชื่อ-นามสกุลเจ้าหน้าที่',
        isu_userlevel: 'ระดับสิทธิ์',
        isu_organize: 'สังกัด',
        isu_username_validate: 'กรุณาระบุชื่อผู้ใช้งาน',
        isu_password_validate: 'กรุณาระบุรหัสผ่าน',
        isu_fullname_validate: 'กรุณาระบุชื่อ-นามสกุลเจ้าหน้าที่',
        isu_userlevel_validate: 'กรุณาระบุข้อมูลระดับสิทธิ์',
        isu_organize_validate: 'กรุณาระบุสังกัดของเจ้าหน้าที่',

        // Information main
        event_name: 'ชื่อเหตุการณ์',
        disaster_type: 'ประเภทสาธารณภัย',
        disaster_detail: 'ลักษณะที่เกิดเหตุ',
        disaster_status: 'สถานะเหตุการณ์',
        disaster_location: 'สถานที่เกิดเหตุ',
        main_organize: 'หน่วยงานหลัก',
        disaster_callDatetime: 'วัน-เวลาที่รับแจ้งเหตุ',
        disaster_level: 'ระดับ',

        // Information => System => General
        systemUser_modal_title: 'ข้อมูลผู้ใช้งาน',
        systemShop_modal_title: 'ข้อมูลร้านค้า/บริการ',
        systemData_modal_title_add: 'เพิ่มข้อมูลพื้นฐานระบบ',
        systemData_modal_title_edit: 'แก้ไขข้อมูลพื้นฐานระบบ',
        systemData_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        systemUser_modal_subtitle: 'รายละเอียดข้อมูลผู้ใช้งาน',
        systemShop_modal_subtitle: 'รายละเอียดข้อมูลร้านค้า/บริการ',
        igeneral_dataGroup: 'กลุ่มข้อมูล',
        igeneral_dataName: 'ชื่อข้อมูล',
        igeneral_dataGroupMain: 'กลุ่มข้อมูลหลัก',
        igeneral_sequence: 'ลำดับ',
        igeneral_id: 'รหัสข้อมูล',
        igeneral_dataGroup_validate: 'กรุณาระบุกลุ่มข้อมูล',
        igeneral_dataName_validate: 'กรุณาระบุชื่อข้อมูล',
        igeneral_dataGroupMain_validate: 'กรุณาระบุกลุ่มข้อมูลหลัก',
        igeneral_sequence_validate: 'กรุณาระบุลำดับ',
        igeneral_status: 'สถานะ',
        igeneral_program_status: `สถานะ\r\n(ระบบ)`,
        igeneral_shop_status: `สถานะ\r\n(ร้านค้า)`,
        igeneral_location: `ตำแหน่งที่ตั้ง`,
        igeneral_desc: `รายละเอียด`,
        igeneral_shop: `ร้านค้า/บริการ`,
        igeneral_rgdate: 'วันที่ลงทะเบียน',
        igeneral_rgtime: 'เวลา',
        igeneral_dvdate: 'วันที่ล่าสุดที่เข้าระบบ',
        igeneral_dvtime: 'เวลา',
        igeneral_shop_type: 'ประเภทร้านค้า',

        // Information => System => Country
        country_province_modal_title_add: 'เพิ่มข้อมูลจังหวัด',
        country_amphur_modal_title_add: 'เพิ่มข้อมูลอำเภอ',
        country_tambon_modal_title_add: 'เพิ่มข้อมูลตำบล',

        country_province_modal_title_edit: 'แก้ไขข้อมูลจังหวัด',
        country_amphur_modal_title_edit: 'แก้ไขข้อมูลอำเภอ',
        country_tambon_modal_title_edit: 'แก้ไขข้อมูลตำบล',

        country_province_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        country_amphur_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        country_tambon_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',

        country_province_code: 'รหัสจังหวัด',
        country_province_name: 'ชื่อจังหวัด',
        country_province_code_validate: 'กรุณาระบุข้อมูลรหัสจังหวัด',
        country_province_name_validate: 'กรุณาระบุชื่อจังหวัด',

        country_amphur_code: 'รหัสเขต/อำเภอ',
        country_amphur_name: 'ชื่อเขต/อำเภอ',
        country_amphur_code_validate: 'กรุณาระบุข้อมูลรหัสเขต/อำเภอ',
        country_amphur_name_validate: 'กรุณาระบุชื่อเขต/อำเภอ',

        country_tambon_code: 'รหัสแขวง/ตำบล',
        country_tambon_name: 'ชื่อแขวง/ตำบล',
        country_tambon_code_validate: 'กรุณาระบุข้อมูลรหัสแขวง/ตำบล',
        country_tambon_name_validate: 'กรุณาระบุชื่อแขวง/ตำบล',
        country_postcode_validate: 'กรุณาระบุรหัสไปรษณีย์',

        country_select_province_validate: 'กรุณาระบุจังหวัด',
        country_select_amphur_validate: 'กรุณาระบุอำเภอ',

        // Information => Initial => Evacuation
        iie_modal_title_add: 'เพิ่มข้อมูลพื้นที่อพยพ',
        iie_modal_title_edit: 'แก้ไขข้อมูลพื้นที่อพยพ',
        iie_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        iie_location_name: 'ชื่อพื้นที่อพยพ',
        iie_access_main: 'การเข้าถึงหลัก',
        iie_access_tempolary: 'การเข้าถึงรอง',
        iie_selectedDisaster_validate: 'กรุณาระบุข้อมูลประเภทสาธารณภัยอย่างน้อย 1 รายการ',

        iie_location_name_validate: 'กรุณาระบุชื่อพื้นที่อพยพ',
        iie_location_detail_validate: 'กรุณาระบุที่อยู่เบื้องต้นสำหรับพื้นที่อพยพ',

        // Information => Initial => Risk level
        irl_modal_title_add: 'เพิ่มข้อมูลระดับความเสี่ยง',
        irl_modal_title_edit: 'แก้ไขข้อมูลระดับความเสี่ยง',
        irl_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',

        irl_disasterSelected_validate: 'กรุณาระบุข้อมูลประเภทสาธารณภัย',
        irl_riskLevel_validate: 'กรุณาระบุระดับของความเสี่ยง',
        irl_description_validate: 'กรุณาระบุคำอธิบายเพิ่มเติม',

        // Information => Initial => Risk area
        ira_modal_title_add: 'เพิ่มข้อมูลพื้นที่เสี่ยงภัย',
        ira_modal_title_edit: 'แก้ไขข้อมูลพื้นที่เสี่ยงภัย',
        ira_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        ira_location_name: 'ชื่อพื้นที่',

        ira_location_name_validate: 'กรุณาระบุชื่อพื้นที่เสี่ยงภัย',
        ira_location_detail_validate: 'กรุณาระบุที่อยู่เบื้องต้นสำหรับพื้นที่เสี่ยงภัย',

        // Information => Initial => Organization info.
        io_modal_title_add: 'เพิ่มข้อมูลหน่วยงาน',
        io_modal_title_edit: 'แก้ไขข้อมูลหน่วยงาน',
        io_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',

        io_organize_code: 'รหัสสังกัด/หน่วยงาน',

        io_location_name_validate: 'กรุณาระบุชื่อสังกัด/หน่วยงาน',
        io_location_detail_validate: 'กรุณาระบุที่อยู่เบื้องต้นสำหรับสังกัด/หน่วยงาน',
        ResponseAreaModalHeader: 'ค้นหาข้อมูลพื้นที่ที่รับผิดชอบ',
        communication_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        communication_modal_title_add: 'เพิ่มข้อมูลการสื่อสาร',
        communication_modal_title_edit: 'แก้ไขข้อมูลการสื่อสาร',
        communication_detail: 'รายละเอียดการสื่อสาร',
        communication_type: 'ประเภทการสื่อสาร',

        // Information => Initial => Disaster prevent
        idp_modal_title_add: 'เพิ่มข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย',
        idp_modal_title_edit: 'แก้ไขข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย',
        idp_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        idp_prevent_name: 'ชื่อระบบป้องกัน',
        idp_prevent_type: 'ประเภทระบบป้องกัน',
        idp_code: 'รหัสระบบป้องกัน',
        idp_prevent_name_validate: 'กรุณาระบุชื่อระบบป้องกัน/บรรเทาสาธารณภัย',

        // Information => Initial => Training course
        itc_modal_title_add: 'เพิ่มข้อมูลหลักสูตรการฝึกอบรม',
        itc_modal_title_edit: 'แก้ไขข้อมูลหลักสูตรการฝึกอบรม',
        itc_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',

        itc_modal_title_add_detail: 'เพิ่มข้อมูลหลักสูตรการฝึกอบรม : รายละเอียดเพิ่มเติม',
        itc_modal_title_edit_detail: 'แก้ไขข้อมูลหลักสูตรการฝึกอบรม : รายละเอียดเพิ่มเติม',
        itc_modal_subtitle_detail: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',

        itc_course_name: 'ชื่อหลักสูตร',
        itc_course_level: 'ระดับหลักสูตร',
        itc_course_name_validate: 'กรุณาระบุชื่อข้อมูลหลักสูตรการฝึกอบรม',
        itc_generation: 'รุ่นที่',
        itc_training_date: 'วันที่ฝึกอบรม',
        itc_training_startdate: 'ฝึกอบรมวันที่',
        itc_training_enddate: 'ถึงวันที่',
        itc_generation_validate: 'กรุณาระบุรุ่น',
        itc_training_startdate_validate: 'กรุณาระบุวันเริ่มการอบรม',
        itc_training_enddate_validate: 'กรุณาระบุวันสิ้นสุดการอบรม',

        // Information => Initial => Man power
        imp_modal_title_add: 'เพิ่มข้อมูลกำลังคน',
        imp_modal_title_edit: 'แก้ไขข้อมูลกำลังคน',
        imp_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',

        imp_modal_title_add_trainingHistory: 'เพิ่มข้อมูลประวัติการฝึกอบรม',
        imp_modal_title_edit_trainingHistory: 'แก้ไขข้อมูลประวัติการฝึกอบรม',

        imp_fullname: 'ชื่อ-นามสกุล',
        imp_organize: 'หน่วยงาน',
        imp_gen: 'รุ่นที่',
        imp_date: 'วันที่',
        imp_update_info: 'ต้องปรับปรุงข้อมูล',
        imp_prefix_name: 'คำนำหน้าชื่อ',
        imp_firstname: 'ชื่อ',
        imp_lastname: 'นามสกุล',
        imp_level: 'ระดับ',
        imp_position: 'ตำแหน่ง',
        imp_start_workDate: 'วันที่เริ่มงาน',
        imp_radio_signal: 'คลื่นวิทยุ',
        imp_response_signal: 'สัญญาณเรียกขาน',
        imp_training: 'หลักสูตรการฝึกอบรม',
        imp_phone_number: 'หมายเลขโทรศัพท์',
        imp_fax: 'แฟกซ์',
        imp_secretary_name: 'ชื่อเลขา',
        imp_secretary_phone: 'เบอร์โทรศัพท์เลขา',
        imp_update_info_date: 'วันที่ปรับปรุงข้อมูลล่าสุด',
        imp_detail: 'รายละเอียดเพิ่มเติม',
        imp_specialication: 'ความเชี่ยวชาญ',
        imp_history_training: 'ประวัติการฝึกอบรม',
        imp_editor: 'ผู้แก้ไข',

        // Information => Initial => Device Equipment
        ide_modal_title_add: 'เพิ่มข้อมูลอุปกรณ์',
        ide_modal_title_edit: 'แก้ไขข้อมูลอุปกรณ์',
        ide_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        ide_device_name: 'ชื่ออุปกรณ์',
        ide_device_type: 'ประเภทอุปกรณ์',
        ide_unit_name: 'หน่วยนับ',
        ide_amount: 'จำนวน',
        ide_device_name_validate: 'กรุณาระบุชื่ออุปกรณ์',
        ide_device_type_validate: 'กรุณาระบุประเภทอุปกรณ์',
        ide_device_unit_validate: 'กรุณาระบุหน่วยอุปกรณ์',

        // Information => Initial => Incident
        ii_modal_title_add: 'เพิ่มข้อมูลชุดเผชิญเหตุ',
        ii_modal_title_edit: 'แก้ไขข้อมูลชุดเผชิญเหตุ',
        ii_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',

        ii_modal_title_add_detail: 'เพิ่มข้อมูลชุดเผชิญเหตุ : รายการชุดเครื่องมือ',

        ii_incident_name: 'ชื่อชุดเผชิญเหตุ',
        ii_severity_level: 'ระดับของความรุนแรง',
        ii_incident_name_validate: 'กรุณาระบุชื่อชุดเผชิญเหตุ',
        ii_device_type: 'ประเภทเครื่องมือฯ',
        ii_device_type_validate: 'กรุณาระบุประเภทเครื่องมือฯ',

        // Information => Initial => Equipment/Vehicle
        iev_modal_title_add: 'เพิ่มข้อมูลเครื่องมือ อุปกรณ์/ยานพาหนะ',
        iev_modal_title_edit: 'แก้ไขข้อมูลเครื่องมือ อุปกรณ์/ยานพาหนะ',
        iev_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',

        iev_equipment_name: 'ชื่อเครื่องมือฯ',
        iev_equipment_group: 'กลุ่มเครื่องมือฯ',
        iev_equipment: 'เครื่องมืออุปกรณ์',
        iev_vehicle: 'ยานพาหนะ',
        iev_equipment_type: 'ประเภทเครื่องมือฯ',
        iev_equipment_number: 'หมายเลขครุภัณฑ์',
        iev_license_car: 'เลขทะเบียน',
        iev_sidecar_number: 'หมายเลขข้างรถ',
        iev_equipment_status: 'สถานะ',
        iev_update_info: 'ต้องปรับปรุงข้อมูล',
        iev_response_contact_name: 'ชื่อผู้รับผิดชอบ',

        iev_header_deviceOfVehicle: 'เพิ่มข้อมูลอุปกรณ์ประจำยานพาหนะ',
        iev_deviceOfVehicle: 'อุปกรณ์ประจำยานพาหนะ',
        iev_deviceOfVehicle_name: 'ชื่ออุปกรณ์',
        iev_deviceOfVehicle_type: 'ประเภท',
        iev_deviceOfVehicle_equipment: 'เครื่องมือ',
        iev_deviceOfVehicle_size: 'ขนาดการใช้งาน',
        iev_deviceOfVehicle_amount: 'จำนวน',
        iev_deviceOfVehicle_unit: 'หน่วยนับ',

        iev_header_historyOfMaintenance: 'เพิ่มข้อมูลประวัติการซ่อมบำรุง',
        iev_historyOfMaintenance: 'ประวัติการซ่อมบำรุง',
        iev_historyOfMaintenance_startdate: 'วันที่ซ่อม',
        iev_historyOfMaintenance_enddate: 'ซ่อมเสร็จ',
        iev_historyOfMaintenance_detail: 'รายละเอียด',

        iev_equipment_name_validate: 'กรุณาระบุชื่อเครื่องมือฯ',
        iev_equipment_group_validate: 'กรุณาระบุกลุ่มเครื่องมือ',
        iev_equipment_type_validate: 'กรุณาระบุประเภทเครื่องมือฯ',
        iev_organize_validate: 'กรุณาระบุหน่วยงานที่รับผิดชอบ',

        iev_deviceOfVehicle_type_validate: 'กรุณาระบุประเภทเครื่องมือ',
        iev_deviceOfVehicle_equipment_validate: 'กรุณาระบุชื่อเครื่องมือ',
        iev_deviceOfVehicle_size_validate: 'กรุณาระบุขนาดของเครื่องมือ',
        iev_deviceOfVehicle_amount_validate: 'กรุณาระบุจำนวนเครื่องมือ',

        iev_historyOfMaintenance_startdate_validate: 'กรุณาระบุวันที่เริ่มซ่อม',
        iev_historyOfMaintenance_enddate_validate: 'กรุณาระบุวันที่ซ่อมเสร็จ',

        // Information => Initial => Building
        ib_modal_title_add: 'เพิ่มข้อมูลอาคาร/สิ่งปลูกสร้าง',
        ib_modal_title_edit: 'แก้ไขข้อมูลอาคาร/สิ่งปลูกสร้าง',
        ib_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',

        ib_building_name: 'ชื่ออาคาร',
        ib_building_location: 'ที่ตั้งอาคาร',
        ib_building_type: 'ประเภทอาคาร',
        ib_business_type: 'ประเภทกิจการ',
        ib_use_type: 'ประเภทการใช้งาน',
        ib_structure_type: 'ประเภทโครงสร้าง',
        ib_topic_building_location_detail: 'รายละเอียดที่อยู่อาคาร/สิ่งปลูกสร้าง',
        ib_building_location_no: 'เลขที่',
        ib_building_location_moo: 'หมู่ที่',
        ib_building_location_mooban: 'หมู่บ้าน',
        ib_building_location_soi: 'ซอย/ตรอก',
        ib_building_location_road: 'ถนน',
        ib_building_location_landNumber: 'หมายเลขที่ดิน',
        ib_building_location_permissDate: 'วันที่อนุญาต',
        ib_building_location_permissOwner: 'ผู้ถือกรรมสิทธิ์',
        ib_building_location_width: 'หน้ากว้าง (เมตร)',
        ib_building_location_height: 'สูง (เมตร)',
        ib_building_location_depth: 'ลึก (เมตร)',
        ib_building_location_floor: 'จำนวนชั้น',
        ib_building_location_floor_aboveground: 'จำนวนชั้น : เหนือพื้น',
        ib_building_location_floor_underground: 'จำนวนชั้น : ใต้ดิน',
        ib_building_location_totalarea: 'พื้นที่รวม (ตร.ม.)',
        ib_building_location_habitat: 'จำนวนที่พักอาศัย (หน่วย)',
        ib_building_location_population: 'จำนวนผู้พักอาศัย (คน)',
        ib_building_location_labor: 'จำนวนแรงงาน (คน)',
        ib_building_location_chemistry: 'สารเคมีในอาคาร',
        ib_building_location_lift: 'ตำแหน่งลิฟท์ดับเพลิง',
        ib_building_location_masterroom: 'ห้องขนาดใหญ่',
        ib_building_location_greenprint: 'ชื่อแฟ้มพิมพ์เขียว',
        ib_building_location_whiteprint: 'ชื่อแฟ้มพิมพ์ขาว',
        ib_building_location_fireconnection: 'ตำแหน่งหัวรับน้ำ',
        ib_building_location_waterzone: 'แหล่งน้ำในอาคาร',

        ib_topic_parking_detail: 'พื่นที่จอดรถขนาดใหญ่',
        ib_topic_parking_width: 'กว้าง (เมตร)',
        ib_topic_parking_length: 'ยาว (เมตร)',
        ib_topic_parking_open: 'เวลาเปิด',
        ib_topic_parking_close: 'เวลาปิด',
        ib_topic_parking_entrance: 'เส้นทางเข้า - ออก',
        ib_topic_parking_helicopter: 'ลานจอดเฮลิคอปเตอร์',
        ib_topic_parking_fire_protect_system: 'ระบบป้องกันอัคคีภัย',

        ib_survey: 'บันทึกสำรวจภาคสนาม',
        ib_building_name_validate: 'กรุณาระบุชื่ออาคาร/สิ่งปลูกสร้าง',

        // Information => Initial => UN Number
        iun_modal_title_add: 'เพิ่มข้อมูลสารเคมี',
        iun_modal_title_edit: 'แก้ไขข้อมูลสารเคมี',
        iun_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',

        iun_chemical_code: 'รหัสสารเคมี',
        iun_chemical_name: 'ชื่อสารเคมี',
        iun_chemical_manage: 'วิธีการจัดการสารเคมี',

        iun_chemical_code_validate: 'กรุณาระบุรหัสสารเคมี',
        iun_chemical_name_validate: 'กรุณาระบุชื่อสารเคมี',

        // Information => Disaster
        id_modal_title_add: 'เพิ่มข้อมูลสาธารณภัย',
        id_modal_title_edit: 'แก้ไขข้อมูลสาธารณภัย',
        id_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        id_disaster_name_validate: 'กรุณาระบุชื่อเหตุการณ์',

        id_call_name: 'ชื่อผู้แจ้งเหตุ',
        id_call_phone: 'เบอร์โทรศัพท์ผู้แจ้งเหตุ',
        id_disaster_reason: 'สาเหตุการเกิดเหตุ',
        id_disaster_reason_detail: 'รายละเอียดเพิ่มเติม (สาเหตุ)',
        id_disaster_level: 'ระดับความรุนแรง',
        id_disaster_level_deail: 'รายละเอียดเพิ่มเติม (ระดับความรุนแรง)',
        id_disaster_area: 'ขนาดพื้นที่ที่ได้รับผลกระทบ',
        id_disaster_movement: 'ความเคลื่อนไหว',
        id_disaster_daily: 'รายงานประจำวัน',
        id_disaster_daily_call: 'ชื่อเรียกเหตุการณ์',
        id_disaster_daily_group1: 'กลุ่มข้อมูลระดับที่ 1',
        id_disaster_daily_group2: 'กลุ่มข้อมูลระดับที่ 2',
        id_disaster_daily_group3: 'กลุ่มข้อมูลระดับที่ 3',
        id_event_file: 'ไฟล์เกี่ยวกับเหตุการณ์',
        id_event_file_type: 'ประเภทไฟล์',
        id_event_file_name: 'ชื่อไฟล์',
        id_event_file_detail: 'คำอธิบายเพิ่มเติม',
        id_event_file_modal_title_add: 'เพิ่มข้อมูลไฟล์เกี่ยวกับเหตุการณ์',
        id_help: 'ข้อมูลการช่วยเหลือ',
        id_help_receive: 'วัน-เวลาที่รับแจ้งเหตุ',
        id_help_work: 'วัน-เวลาที่ออกปฏิบัติงาน',
        id_help_socialWorker: 'ชื่อนักสังคมสงเคราะห์',
        id_help_modal_title_add: 'เพิ่มข้อมูลการช่วยเหลือ',
        id_help_modal_title_edit: 'แก้ไขข้อมูลการช่วยเหลือ',
        id_operating: 'หน่วยงานที่ออกปฏิบัติการ',
        id_operating_name: 'ชื่อหน่วยงาน',
        id_operating_receive: 'รับแจ้งเหตุ',
        id_operating_work: 'ออกปฏิบัติงาน',
        id_operating_arrive: 'ถึงจุดเกิดเหตุ',
        id_operating_leave: 'ออกจากจุดเกิดเหตุ',
        id_operating_destination: 'กลับถึงที่ตั้ง',
        id_operating_man: 'กำลังคน',
        id_operating_vehicle: 'ยานพาหนะ',
        id_operating_mainOrganize: 'หน่วยงานหลัก',
        id_operating_modal_title_add: 'เพิ่มข้อมูลหน่วยงานที่ออกปฏิบัติการ',
        id_operating_modal_title_edit: 'แก้ไขข้อมูลหน่วยงานที่ออกปฏิบัติการ',
        id_operating_modal_type: 'ประเภทหน่วยงาน',
        id_operating_modal_name: 'ชื่อหน่วยงาน',
        id_operating_modal_receive: 'วัน-เวลาที่รับแจ้งเหตุ',
        id_operating_modal_work: 'วัน-เวลาที่ออกปฏิบัติงาน',
        id_operating_modal_arrive: 'วัน-เวลาที่ถึงจุดเกิดเหตุ',
        id_operating_modal_leave: 'วัน-เวลาที่ออกจากจุดเกิดเหตุ',
        id_operating_modal_destination: 'วัน-เวลาที่กลับถึงที่ตั้ง',
        id_operating_modal_man: 'จำนวนเจ้าหน้าที่',
        id_operating_modal_vehicle: 'จำนวนยานพาหนะ',
        id_operating_modal_checkMainOrganize: 'หน่วยงานหลัก',

        // Information => Victim
        disasterEventModalHeader: 'ค้นหาข้อมูลเหตุการณ์สาธารณภัย',
        iv_victim_name: 'ชื่อผู้ประสบภัย',
        iv_victim_idnumber: 'หมายเลขบัตรประชาชน',
        iv_victim_status: 'สถานภาพ',
        iv_victim_disaster: 'เหตุการณ์สาธารณภัย',
        iv_victim_disaster_date: 'วันที่รับแจ้งเหตุ',

        iv_table_headerFamily: 'หัวหน้าครอบครัว',
        iv_table_address: 'ที่อยู่',

        iv_modal_title_add: 'เพิ่มข้อมูลผู้ประสบภัย (ครอบครัว)',
        iv_modal_title_edit: 'แก้ไขข้อมูลผู้ประสบภัย (ครอบครัว)',
        iv_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        iv_modal_help_topic: 'การช่วยเหลือครอบครัว',
        iv_modal_help_consumer: 'เครื่องอุปโภคบริโภค',
        iv_modal_help_temporary: 'ค่าที่พักอาศัยชั่วคราว',
        iv_modal_help_occupation: 'เงินทุนประกอบอาชีพ',
        iv_modal_help_contribution: 'เงินสมทบ',
        iv_modal_member_topic: 'สมาชิกในครอบครัว',
        iv_member_table_no: 'ลำดับ',
        iv_member_table_name: 'ชื่อ-นามสกุล',
        iv_member_table_relationship: 'ความสัมพันธ์',
        iv_member_table_gender: 'เพศ',
        iv_male: 'ชาย',
        iv_female: 'หญิง',
        iv_member_table_age: 'อายุ',
        iv_member_table_nationality: 'สัญชาติ',
        iv_member_table_occupation: 'อาชีพ',

        iv_submodal_title_add: 'เพิ่มข้อมูลผู้ประสบภัย (บุคคล)',
        iv_submodal_title_edit: 'แก้ไขข้อมูลผู้ประสบภัย (บุคคล)',
        iv_submodal_race: 'เชื้อชาติ',
        iv_submodal_religion: 'ศาสนา',
        iv_submodal_age: 'อายุ (ปี)',
        iv_submodal_bloodgroup: 'หมู่โลหิต',
        iv_submodal_checkedOfficer: 'เป็นเจ้าหน้าที่',
        iv_submodal_effectdetail: 'ข้อมูลที่ได้รับผลกระทบ',

        iv_submodal_basichelp_topic: 'การช่วยเหลือเบื้องต้น',
        iv_submodal_basichelp_hospital: 'ค่ารักษาพยาบาล',
        iv_submodal_basichelp_consolation: 'ค่าปลอบขวัญ',
        iv_submodal_basichelp_corpsemanage: 'ค่าจัดการศพ',
        iv_submodal_basichelp_cost: 'ค่าครองชีพ',
        iv_submodal_otherhelp_topic: 'การช่วยเหลืออื่น ๆ',
        iv_submodal_otherhelp_name: 'ชื่อขอความช่วยเหลือ',
        iv_submodal_otherhelp_organize: 'หน่วยงานที่ช่วยเหลือ',
        iv_submodal_otherhelp_money: 'จำนวนเงิน (บาท)',
        iv_submodal_damage_topic: 'ความเสียหาย (ทรัพย์สิน)',
        iv_submodal_damage_asset: 'ชื่อทรัพย์สิน',
        iv_submodal_damage_detail: 'รายละเอียด',
        iv_submodal_damage_level: 'ระดับความเสียหาย',
        iv_submodal_damage_estimate: 'ราคาประเมิน (บาท)',
        iv_disaster_name_validate: 'กรุณาระบุชื่อเหตุการณ์',

        // Information => Statistic
        is_modal_title: 'แก้ไขข้อมูลสถิติจำนวนประชากร',
        is_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        is_organize_code: 'รหัสหน่วยงาน',
        is_organize_name: 'ชื่อหน่วยงาน',
        is_year: 'ปี (พ.ศ.)',
        is_population: 'จำนวนประชากร (คน)',
        is_add_list: 'เพิ่มรายการ',

        is_year_validate: 'กรุณาระบุปี (พ.ศ.)',
        is_population_validate: 'กรุณาระบุจำนวนประชากร',

        // Information => Admin => Menu
        iam_modal_title_add: 'เพิ่มข้อมูลเมนูการใช้งาน',
        iam_modal_title_edit: 'แก้ไขข้อมูลเมนูการใช้งาน',
        iam_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',
        iam_menugroup_code: 'รหัสกลุ่มเมนู',
        iam_menugroup_name: 'ชื่อกลุ่มเมนู',
        iam_topic_setting_menu: 'กำหนดค่าเมนู',
        iam_setting_code: 'รหัส',
        iam_setting_type: 'ประเภท',
        iam_setting_file: 'ไฟล์',
        iam_setting_menuname: 'ชื่อเมนู',
        iam_setting_usage: 'การใช้งาน',
        iam_setting_usage_view: 'เรียกดู',
        iam_setting_usage_manage: 'จัดการข้อมูล',
        iam_setting_usage_manage_add: 'เพิ่ม',
        iam_setting_usage_manage_edit: 'แก้ไข',
        iam_setting_usage_manage_delete: 'ลบ',
        iam_menugroup_name_validate: 'กรุณาระบุชื่อกลุ่มเมนู',
        iam_menugroup_code_validate: 'กรุณาระบุรหัสกลุ่มเมนู',

        // Information => Admin => Config
        config_modal_title: 'แก้ไขข้อมูล Configuration',
        config_modal_subtitle: 'กรุณาระบุรายละเอียดให้ครบถ้วนก่อนบันทึกข้อมูล',

        isu_permission_validate: 'กรุณาระบุข้อมูลระดับสิทธิ์',
        iie_organize_validate: 'กรุณาระบุข้อมูลหน่วยงานที่รับผิดชอบ',
        selectedDisaster_validate: 'กรุณาระบุประเภทสาธารณภัย',

        io_selectedTambon_validate: 'กรุณาระบุตำบล',
        io_selectedAmphur_validate: 'กรุณาระบุอำเภอ',
        io_selectedProvince_validate: 'กรุณาระบุจังหวัด',
        io_organizeTypeSelect_validate: 'กรุณาระบุประเภทสังกัด/หน่วยงาน',
        io_organizename_validate: 'กรุณาระบุชื่อสังกัด/หน่วยงาน',
        io_error_selectedResponseArea_validate: 'กรุณาระบุพื้นที่ที่รับผิดชอบอย่างน้อย 1 รายการ',
        io_contact_phone: 'เบอร์โทรศัพท์ผู้ติดต่อ',
        io_contact_name: 'ชื่อผู้ติดต่อ',
        io_website: 'เว็บไซต์',

        idp_prevent_type_validate: 'กรุณาระบุประเภทระบบป้องกันฯ',

        itc_course_level_validate: 'กรุณาระบุระดับสูตรการฝึกอบรม',

        imp_start_workDate_validate: 'กรุณาระบุวันที่เริ่มงาน',
        imp_organize_validate: 'กรุณาระบุหน่วยงานต้นสังกัด',
        imp_prefix_name_validate: 'กรุณาระบุคำนำหน้าชื่อ',
        imp_firstname_validate: 'กรุณาระบุชื่อ',
        imp_lastname_validate: 'กรุณาระบุนามสกุล',
        clearImage: 'ยกเลิก',

        vehicle: 'ยานพาหนะ',
        device: 'เครื่องมืออุปกรณ์',
        status_ready: 'พร้อมใช้',
        status_fix: 'ซ่อม',
        status_bad: 'ชำรุด',

        suggest_validate_name: 'กรุณาระบุชื่อผู้เสนอแนะ',
        suggest_validate_emailphone: 'กรุณาระบุ Email / เบอร์โทรศัพท์',
        suggest_validate_topic: 'กรุณาระบุหัวข้อ',
        suggest_validate_detail: 'กรุณาระบุรายละเอียด',

        ib_building_organize_validate: 'กรุณาระบุหน่วยงานที่รับผิดชอบ',
        ib_building_type_validate: 'กรุณาระบุประเภทอาคาร',
        ib_business_type_validate: 'กรุณาระบุประเภทกิจการ',

        onworking: 'กำลังดำเนินการ',
        finish: 'เสร็จสิ้น',
        ft_clip: 'คลิป',
        ft_image: 'รูปภาพ',
        ft_other: 'ไฟล์อื่น ๆ',
        id_event_file_name_validate: 'กรุณาระบุชื่อไฟล์',
        id_fileTypeSelect_validate: 'กรุณาระบุประเภทไฟล์',
        id_fileurl_validate: 'กรุณาเลือกไฟล์',

        id_help_receive_validate: 'กรุณาระบุวัน-เวลาที่รับแจ้งเหตุ',
        id_help_work_validate: 'กรุณาระบุวัน-เวลาที่ออกปฏิบัติงาน',

        id_disasterTypeSelect_validate: 'กรุณาระบุข้อมูลประเภทสาธารณภัย',
        id_selectedProvince_validate: 'กรุณาระบุข้อมูลจังหวัด',
        id_selectedAmphur_validate: 'กรุณาระบุข้อมูลอำเภอ',
        id_selectedTambon_validate: 'กรุณาระบุข้อมูลตำบล',
        id_operating_modal_name_validate: 'กรุณาระบุข้อมูลหน่วยงานที่ออกปฏิบัติการ',

        all: 'เสียหายทั้งหมด',
        some: 'เสียหายบางส่วน',
        ivs_firstname_validate: 'กรุณาระบุชื่อผู้ประสบภัย',
        ivs_victimStatusSelected_validate: 'กรุณาระบุสถานภาพผู้ประสบภัย',
        iv_submodal_otherhelp_name_validate: 'กรุณาระบุชื่อขอความช่วยเหลือ/ประเภทขอความช่วยเหลือ',
        iv_submodal_damage_asset_validate: 'กรุณาระบุชื่อทรัพย์สิน',
        iv_submodal_damage_level_validate: 'กรุณาระบุระดับความเสียหาย',
        member_table_validate: 'กรุณาระบุข้อมูลผู้ประสบภัย',

        is_year_add_validate: 'มีข้อมูลปีดังกล่าวแล้วกรุณาลองใหม่',
        is_year_add_format_validate: 'กรุณาระบุปีในรูปแบบ YYYY',

        //Report - officer
        agency: 'หน่วยงานต้นสังกัด',
        officerlevel: 'ระดับเจ้าหน้าที่',
        responsework: 'งานที่รับผิดชอบ',
        disaster_related: 'สาธารณภัยที่เกี่ยวข้อง',
        officer_amount: 'จำนวน (คน)',
        fullname: 'ชื่อ-นามสกุล',
        response_signal: 'สัญญาณเรียกขาน',

        //Report - Equipment
        organize_response: 'หน่วยงานรับผิดชอบ',
        group: 'กลุ่มเครื่องมือฯ',
        type: 'ประเภทเครื่องมือฯ',
        name: 'ชื่อเครื่องมือฯ',
        ct_name: 'ชื่อผู้ติดต่อ',
        ct_phone: 'หมายเลขผู้ติดต่อ',
        label_type_device: 'ประเภทเครื่องมือ/อุปกรณ์',
        label_type_vehicle: 'ประเภทยานพาหนะ',
        status: 'สถานะ',
        amount: 'จำนวน',

        //Report - building
        amount_building: 'จำนวน (อาคาร)',
        ch_1: 'ไม่ระบุ',
        ch_2: '1-4',
        ch_3: '5-7',
        ch_4: '8-20',
        ch_5: 'มากกว่า 20',

        //Report - Risk area
        amount_area: 'จำนวน (พื้นที่)',
        level_effect: 'ระดับความรุนแรง',
        level_1: 'ระดับที่ 1',
        level_2: 'ระดับที่ 2',
        level_3: 'ระดับที่ 3',
        level_4: 'ระดับที่ 4',
        level_5: 'ระดับที่ 5',
        locarion_risk_area: 'ที่ตั้งพื้นที่เสี่ยงภัย',

        //Report - Local event
        local_event: 'พื้นที่เกิดเหตุ',
        amount_time: 'จำนวน(ครั้ง)',
        startYear: 'ปีเริ่มต้น',
        endYear: 'ปีสิ้นสุด',
        TopicGraphReportDisaster_byType_month: 'กราฟสรุปจำนวนเหตุการณ์สาธารณภัยตามประเภทสาธารณภัย - รายเดือน',
        TopicGraphReportDisaster_byType_year: 'กราฟสรุปจำนวนเหตุการณ์สาธารณภัยตามประเภทสาธารณภัย - รายปี',
        TopicGraphReportDisaster_byLocal_month: 'กราฟสรุปจำนวนเหตุการณ์สาธารณภัยตามพื้นที่เกิดเหตุ - รายเดือน',
        TopicGraphReportDisaster_byLocal_year: 'กราฟสรุปจำนวนเหตุการณ์สาธารณภัยตามพื้นที่เกิดเหตุ - รายปี',

        //Report - Victim
        howto: 'การช่วยเหลือครอบครัว',
        address_locate: 'พื้นที่ตามที่อยู่',
        vstatus_1: 'ไม่ระบุ',
        vstatus_2: 'เสียชีวิต',
        vstatus_3: 'บาดเจ็บ',
        vstatus_4: 'สูญหาย',
        amount_event_time: 'จำนวนเหตุการณ์ (ครั้ง)',
        amount_victim: 'จำนวนผู้ประสบภัย (คน)',
        amount_damage: 'มูลค่าความเสียหาย (บาท)',
        victim_status: 'สถานภาพผู้ประสบภัย',
        other: 'อื่น ๆ',
        TopicGraphReportVictim_byType_month: 'กราฟสรุปจำนวนผู้ประสบภัยตามประเภทสาธารณภัย - รายเดือน',
        TopicGraphReportVictim_byType_year: 'กราฟสรุปจำนวนผู้ประสบภัยตามประเภทสาธารณภัย - รายปี',
        TopicGraphReportVictim_byLocal_month: 'กราฟสรุปจำนวนผู้ประสบภัยตามพื้นที่เกิดเหตุ - รายเดือน',
        TopicGraphReportVictim_byLocal_year: 'กราฟสรุปจำนวนผู้ประสบภัยตามพื้นที่เกิดเหตุ - รายปี',

        TopicGraphRiskArea: 'กราฟสรุปจำนวนพื้นที่เสี่ยงภัย - ตามพื้นที่เสี่ยงภัย',
        RiskAreaLocation: 'ที่ตั้งพื้นที่เสี่ยงภัย',

        TopicGraphStatisticDisaster: 'สถิติสาธารณภัย',
        startMonthYear: 'เดือน-ปี เริ่มต้น',
        endMonthYear: 'เดือน-ปี สิ้นสุด',
        month: 'เดือน',

        TopicGraphReportDisaster: 'สถิติสาธารณภัยตามประเภทสาธารณภัย - จัดกลุ่มตามช่วงเวลา',
        TopicGraphReportDisaster_Year: 'สถิติสาธารณภัยตามประเภทสาธารณภัย - เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี',

        TopicGraphReportLevel: 'สถิติสาธารณภัยตามระดับของความรุนแรง - จัดกลุ่มตามช่วงเวลา',
        TopicGraphReportLevel_Year: 'สถิติสาธารณภัยตามระดับของความรุนแรง - เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี',

        TopicGraphReportOrganize: 'สถิติสาธารณภัยตามหน่วยงานรับผิดชอบ - จัดกลุ่มตามช่วงเวลา',
        TopicGraphReportOrganize_Agency: 'สถิติสาธารณภัยตามหน่วยงานรับผิดชอบ - จัดกลุ่มตามหน่วยงานรับผิดชอบ',
        TopicGraphReportOrganize_Year: 'สถิติสาธารณภัยตามหน่วยงานรับผิดชอบ - เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี',

        TopicGraphReportLocation: 'สถิติสาธารณภัยตามพื้นที่เกิดเหตุ - จัดกลุ่มตามช่วงเวลา',
        TopicGraphReportLocation_Location: 'สถิติสาธารณภัยตามพื้นที่เกิดเหตุ - จัดกลุ่มตามเขตพื้นที่เกิดเหตุ',
        TopicGraphReportLocation_Year: 'สถิติสาธารณภัยตามพื้นที่เกิดเหตุ - เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี',

        table_validate: 'กรุณาระบุข้อมูลอย่างน้อย 1 รายการ',

        export: 'ส่งออก',

        searchYearStart: 'ปีเริ่มต้น',
        searchYearEnd: 'ปีสิ้นสุด',

        searchYearStart_validate: 'กรุณาระบุปีเริ่มต้น',
        searchYearEnd_validate: 'กรุณาระบุปีสิ้นสุด',

        ivs_idnumber_validate: 'กรุณาระบุเลขประจำตัวประชาชน 13 หลัก',

        NoImageEquipment: 'ไม่พบรูปภาพ',
        imageEquipment: 'รูปภาพเครื่องมือ อุปกรณ์/ยานพาหนะ',

        starttime: 'เวลาเริ่มต้น',
        endtime: 'เวลาสิ้นสุด',
        action_topic: 'การจัดการ',
        action_time: 'วัน-เวลาที่จัดการข้อมูล',
        json: 'ชุดข้อมูล',
        invalid_starttime: 'กรุณาเลือกวันเริ่มต้น',
        invalid_endtime: 'กรุณาเลือกวันสิ้นสุด',
        error_login_username: 'ข้อมูลผู้ใช้งานไม่ถูกต้อง',
        error_login_password: 'ข้อมูลรหัสผ่านไม่ถูกต้อง',
    }

}